var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70555 2.61385L11.5535 5.46174L4.3446 12.6706L1.4983 9.82272L8.70555 2.61385ZM13.7145 1.92701L12.4444 0.656944C11.9536 0.16611 11.1566 0.16611 10.6641 0.656944L9.44748 1.87354L12.2954 4.72145L13.7145 3.30237C14.0952 2.92165 14.0952 2.3077 13.7145 1.92701ZM0.00792508 13.8257C-0.0439034 14.0589 0.166693 14.2679 0.399974 14.2112L3.5735 13.4417L0.727197 10.5938L0.00792508 13.8257Z",
    fill: "#004494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.4d5c8d59b01e92fa583ffe69dff549c0.svg";
export { ForwardRef as ReactComponent };